import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=04b7ff3d&scoped=true&"
import script from "@/components/Breadcrumbs/Breadcrumb.ts?vue&type=script&lang=ts&"
export * from "@/components/Breadcrumbs/Breadcrumb.ts?vue&type=script&lang=ts&"
import style0 from "@/components/Breadcrumbs/breadcrumb.scss?vue&type=style&index=0&id=04b7ff3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b7ff3d",
  null
  
)

export default component.exports